import { useContext } from 'react';
import { NotificationDialogContext } from './context';

export const useNotifilcationDialog = () => {
  const context = useContext(NotificationDialogContext);
  if (!context) {
    throw new Error('useAlert must be used within an AlertProvider');
  }
  return context;
};
